import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Sales by Product";
const description = `The "Sales by Product" report is a crucial tool for analyzing the sales performance of individual items. It provides a detailed history of how each product has been selling over a specific period, including the quantity sold, total revenue generated, and other key metrics. By tracking this data, businesses can easily identify their top-selling products, pinpoint slow-moving inventory, and make informed decisions about future marketing, pricing, and purchasing strategies.`;

const images = [
    '/images/reports/sales/sales-by-product/sales-by-product.png', // 0
];


const SalesByProduct: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SalesByProduct;
